import React from "react";
import { Row, Col } from "reactstrap";
import { useParams } from "react-router-dom";
import { CandidateProfileEditor } from "@workspace/portfolio/src/pages";

function CandidatePortfolio() {
  const { candidateId } = useParams();
  return (
    <div>
      <Row className="mb-4">
        <Col>
          <h5 className="fw-semibold">Edit Candidate Portfolio</h5>
          <span className="text-muted">Make changes to candidate portfolio below.</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <CandidateProfileEditor selectedCandidateId={candidateId} />
        </Col>
      </Row>
    </div>
  );
}

export default CandidatePortfolio;
